import styled from "styled-components";

export const SinglePageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 600px;
  background-color: rgba(0, 0, 0, 0.5); // Adjust the opacity as needed

  @media only screen and (max-height : 500px) {
    height :300px
  }
`;


const StyledSinglePage = styled.div<{ main_banner_image: string }>`
    .bg-image {
        background-image: url(${props => props.image});
        background-repeat : no-repeat;

    }

     @media only screen and (max-height : 500px) {
    .bg-image {
    height :300px
    }
}
`

export default StyledSinglePage
